module.exports = __webpack_public_path__ + "img/mantraz-logo-horizontal-on-dark.3d844f22.svg";